import { Reveal } from "@/components/site/motion";

export const Eyebrow = ({ children, className = "" }) => (
  <div className={`eyebrow flex items-center gap-3 text-fg-3 ${className}`}>
    <span>{children}</span>
  </div>
);

export const SectionIntro = ({ label, title, text, className = "", titleClass = "" }) => (
  <div className={`grid gap-8 lg:grid-cols-12 ${className}`}>
    <div className="lg:col-span-3">
      <Reveal><Eyebrow>{label}</Eyebrow></Reveal>
    </div>
    <div className="lg:col-span-9">
      <Reveal>
        <h2 className={`text-[2rem] sm:text-5xl lg:text-[3.6rem] font-[540] leading-[1.02] tracking-[-0.035em] text-fg max-w-[18ch] ${titleClass}`}>
          {title}
        </h2>
      </Reveal>
      {text && (
        <Reveal delay={0.08}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-fg-2">{text}</p>
        </Reveal>
      )}
    </div>
  </div>
);
